.loading-main-content {
  opacity: 0.3;
}

.main-content {
  opacity: 1;
  height: 100%;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvUm91dGVyIiwic291cmNlcyI6WyJSb3V0ZXIuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFOzs7QUFHRjtFQUNFO0VBQ0EiLCJzb3VyY2VzQ29udGVudCI6WyIubG9hZGluZy1tYWluLWNvbnRlbnQge1xuICBvcGFjaXR5OiAwLjM7XG59XG5cbi5tYWluLWNvbnRlbnQge1xuICBvcGFjaXR5OiAxO1xuICBoZWlnaHQ6IDEwMCU7XG59XG4iXX0= */